import idLocale from "element-ui/lib/locale/lang/id";
import { performanceId } from "../temp/performance-id";
import trans from "@/doc/lang/_indo.json";
// import hom from "@/doc/hom/_indo.json";
import { lxyLangId } from "../lxyLangs/id";
import { fhbLangId } from "../fhbLangs/id";
import { lssLangId } from "../lssLangs/id";
// import { langEn } from "../lgyLangs/en";
// import { fhbLangEn } from "../fhbLangs/en";
import { wrhLangId } from "../wrhLangs/id";
import { DyLangId } from "../DyLangs/id";
// import { lxyLangEn } from "../lxyLangs/en";
 import { lgyLangId } from "../lgyLangs/id";

const id = {
    normal: "Normal",
    outsourcing: "Outsourcing",
    English: "Bahasa Inggris",
    española: "Bahasa Spanyol",
    India: "Hindi",
    authority: {
        createNewUser: "Buat user baru"	,
        enterName: "Masukkan nama",
        enterEmail:"Masukan email",
        enterRole: 	"Masukkan peran",
        enterCountry: 	"Masukkan negara",
        enterID: "Masukkan nomor id karyawan",
        enterPassword: 		"Masukkan kata sandi",
        password: 		"kata sandi",
        modifyPassword: 		"ganti kata sandi",
        oldPassword: 		"password lama",
        newPassword: 		"kata sandi baru",
        confirmPassword: 		"Konfirmasi kata sandi baru",
        confirmTheChanges: 	"Konfirmasi perubahan",
        ifForgotContactLeader: 		"Jika Anda lupa kata sandi Anda, silakan hubungi leader anda",
        disaccordWithThFirsPassword: 		"Kedua kata sandi tidak sama",
        passwordRules: 		"Kata sandi harus berisi huruf besar dan kecil, angka, dan simbol, tanpa nama user, dan setidaknya 8 karakter",
        name: 		"Nama",
        email: 	 	"Email",
        role: 	 	"Peran" ,
        country: 		"negara",
        operator: 	 	"Operator",
        operate: 	 	"Lakukan",
        Disable: 		"Disable",
        Enable: 		"Enable",
        enableGoogleVerification: 	 	"Aktifkan verifikasi Google",
        requiredFields: 	 	"Harus di isi",
        pleaseFillInCorrectly: 		"Mohon diisi dengan benar",
        edit: 	 	"Edit",
        delete: 	 	"Hapus",
        add: 		"Tambahkan",
        confirmDelete: 	 	"Konfirmasi hapus?",
        cancel: 	 	"Batalkan",
        ok: 		"Setuju",
        search: "Cari",
        operateTime: "Waktu pengoperasian",
        roleManagement: 'Manajemen peran',
        containsSubordinateLevelsAndCannotBeDeleted:"Ada level bawahan dan tidak bisa dihapus",
        addaFirstLevelRole: 		'Tambahkan peran tingkat pertama',
        roleRightsManagement: 		"Manajemen otoritas peran",
        permissionAssignment: 	 	"Otorisasi peran",
        operationAuthority: 	 	"Otoritas pengoperasian",
        dataAuthority: 		"Izin data",
        pleaseEnteraKeyword: 	 	"Silakan masukkan kata kunci",
        passwordVerification:  	"Kata sandi harus berisi huruf besar dan kecil, angka, dan simbol. Anda tidak dapat menggunakan nama Anda sebagai kata sandi",
        passwordDoesNotContainCapitalLettersPleaseFillInAgain:"Password tidak mengandung huruf kapital, mohon diisi kembali",
        passwordDoesNotContainLowercaseLettersPleaseFillInAgain:			"Password tidak mengandung huruf kecil, mohon diisi ulang",
        thePasswordDoesNotContainNumbersPleaseFillInAgain:			"Password tidak mengandung angka, silahkan isi ulang",
        passwordDoesNotContainCharactersPleaseFillInAgain:
              	"Kata sandi tidak mengandung karakter, silakan isi lagi",
        cantUseYourNameAsPasswordPleaseFillInAgain:			"Nama anda tidak dapat digunakan sebagai password, silahkan isi ulang",
        repeatPasswordPleaseFillInAgain: 	"Ulangi kata sandi, silakan isi lagi",
        disaccordWithTheFirstPassword: 		"Kedua kata sandi tidak konsisten",
        mailboxAlreadyExistsPleaseFillInAgain: 	"Kotak surat sudah ada, silahkan isi lagi",
        theRoleContainsUsersAndCannotBeDeleted: 	"Peran berisi pengguna dan tidak dapat dihapus",
        roleGroupManagement: 	 	"Manajemen kelompok peran",
        roleGroup: 		"Kelompok peran",
        createGroup: 	 	"Buat group baru",
        groupRoleAddedSuccessfully: 	 	"Peran grup telah berhasil ditambahkan",
        roleExistsInRoleGroupDeletionFailed: 		"Ada peran dalam grup peran dan tidak dapat dihapus",
        groupPermissionManagement: 		"Manajemen otoritas grup",
        permissionAssignmentSucceeded: 	 	"Izin berhasil ditetapkan",
      },
      collectWorkOrders: {
        ticketAtttibuteConfiguration: 	"Konfigurasi periode waktu",
        singlePeriodDays: 		"Konfigurasi periode waktu (jumlah hari) - tiket normal",
        installmentDays: 		"Konfigurasi periode waktu (jumlah hari) -tiket cicilan",
        delete: 		"Hapus",
        save: 		"Simpan",
        addCustomWorkOrderLevels: 		"Tambahkan level tiket khusus",
        areYouSureToDelete: 		"Apakah Anda yakin akan menghapus konfigurasi penagihan ini?",
        cancel: 		"Batalkan",
        confirm: 		"Setuju",
        deleteAll: 		"Hapus semua",
        edit: 		"Edit",
        pleaseSetaCoherentLevel: 		"Silakan atur tingkat kontinuitas",
        pleaseSetaDifferentLevel: 		"Silakan atur level yang berbeda",
      },
      performance: {
        rollfinishnum: 'Roll Finish Num',
        staffPerformance: 		"Manajemen kinerja personel",
        ticketCategory: 		"Klasifikasi tiket kerja",
        role: 		"Peran",
        time: 		"Periode Waktu",
        staff: 		"Karyawan",
        email: 		"Email",
        search: 		"Cari",
        clear: 		"Hapus",
        refresh: 		"Refresh",
        export: 		"Export",
        date: 		"Tanggal",
        ranking: 		"Ranking",
        totalLeftUnpaidPrincipal: 		"Sisa pinjaman yang belum dibayar",
        repayPrincipal: 		"Pinjaman yang sudah di bayar",
        repayInterest: 		"Bunga yang sudah dibayar",
        totalRepayAmount: 		"Total pengembalian dana",
        repayRate: 		"Rasio pengembalian dana",
        targetRepayRate: 		"Rasio Target pengembalian dana",
        diffTargetRepayAmount: 		"Dana belum di kembalikan dari target",
        newAssignNum: 		"Tiket baru diberikan" ,
        handleTimes: 		"Berapa kali tiket di proses",
        handleNum: 		"Jumlah penanganan",
        completeNum: 		"Jumlah penyelesaian",
        loadNum: 	"	Jumlah target diberikan",
        performanceComparison: 		"Perbandingan kinerja",
        type: 		"Jenis perbandingan kinerja",
        belongedGroup: 		"Grup yang dimiliki",
        staffOptional: 		"Karyawan (opsional)",
        pleaseChoose: 		"Pilih",
        YesNoLastorderrule: 		"Ya/Tidak terakhir kali tiket dibagi",
        byStaff: 		"Oleh karyawan",
        byGroup: 		"Berdasarkan peran",
        byGroup1: 		"Berdasarkan peran",
        byGroup2: 		"Dengan kelompok besar",
        pleaseChooseaRole: 		"Pilih peran",
        noStaffsUnderThisGroupWereFoundPleaseConfirmWhetherTheGroupAndStaffMatches:		"Tidak ada anggota grup yang ditemukan, harap konfirmasi apakah nama grup dan karyawan cocok",
        dashboard: 		"Dashboard",
        groupTotalRepayAmount: 		"Pengembalian pinjaman oleh grup",
        groupRepayRate: 		"Rasio pengembalian grup",
        groupKPI: 	"	KPI group",
        groupCompleteNum: 		"Jumlah yang diselesaikan grup",
        groupRanking: 		"Ranking grup",
        group: 		"Grup",
        staffRanking: 		"Ranking staff grup",
        name: 		"Nama",
        newtab: 		"Buka tab baru",
        completeLabel:  		"Performasi selesai",
        completed:  		"selesai",
        inCompleted:  		"Bertahanlah di udara",
        repayAmount: 'Jumlah koleksi',
        repayTime: 'Waktu masuk bank',
        notifyTime: 'Waktu pemberitahuan bank',
        jsIndex: 'Nomor seri',
        businessTime: 'Waktu pemberitahuan parti bisnis'
      },
      performance2: {
        bucket: "Bucket",
        fecha: "Date",
        avgcalltime: "Avg Call Times",
        difcalltime: "Dif Call Times",
        avgrepayrate: "Avg Repay Rate",
        hourlyachievementsents: "Hourly Achievements Ents",
        totalallocationamount: "Total Allocation Amount",
        totalrepayamount: "Total Repay amount",
        hourlytarget: "Hourly Target",
        completerate: "Complete Rate"
      },
      orderInfo: {
        BadDebts: "Hutang buruk",
      },
      ticket: {
        normal: 		'normal',
        abnormal:   'anormal',
        PaymentCodeStatus: 		"Status kode pembayaran",
        PaymentCodeAmount: 		"Jumlah kode pembayaran",
        PaymentCode: 		"Kode pembayaran",
        ThirdPartyName: 		"Nama pihak ketiga",
        Mobile: 		"Nomor HP",
        VA: 		"VA",
        OXXOCode: 		"kode OXXO",
        PaynetCode: 		"kode paynet",
        AccountId: 		"ID Akun",
        InvalidTime: 		"Waktu kedaluwarsa",
        RemainingAmount: 		"Sisa pembayaran",
        collectTicketSystem: 		"Sistem tiket kerja penagihan",
        systemManager: 	 	"Manajemen perintah kerja",
        ticketID: 	 	"ID tiket",
        loanID: 	 	"ID pinjaman",
        userID: 	 	"ID pengguna",
        caseID: 	 "	ID kasus",
        ticketAssignToName: 	 	"Tiket diberikan ke (nama)",
        ticketAssignToId: 	 	"Tiket diberikan ke  (id)",
        ticketCreateTime: 	 	"Waktu pembuatan tiket",
        completeTime: 	 	"Waktu selesai",
        closeTime: 	 	"Waktu ditutup",
        assignTime: 	 	"Waktu dibagikan",
        ticketStatus: 	 	"Status tiket",
        ticketCategory: 	 	"Kaegori tiket",
        search: 	 	"Cari",
        batchAssign: 	 	"Bagikan semua tiket",
        emailNameExport: "Email List Export",
        batchRecover: 	 	"Tarik semua tiket",
        batchOutsourcing: 	 	"Bagikan semua tiket ke pihak ketiga",
        batchRecall: "Penarikan Balik Massal Untuk Interna",
        dataExport: 	 	"Export data",
        handleTime: 	 	"Berapa Kali Tiket di Proses",
        lastCommunicationResult: 	 	"Waktu penanganan terakhir",
        nextCommunicationResult: 	 	"Waktu penanganan berikutnya",
        partialCompleteTime: 	 	"Waktu penyelesaian sebagian",
        expirationTime: 	 	"Tanggal kadaluarsa",
        operation: 	 	"Lakukan",
        attributeConfigure: 	 	"Konfigurasi atribut",
        ticketBasicAttribute: 	 	"Dasar atribut tiket",
        attributeNumber: 	 	"Nomor atribut",
        attributeName: 	 	"Nama atribut",
        foundTime: 	 	"Waktu dibuat",
        ticketCombineAttribute: 	 	"Atribut portofolio tiket kerja",
        newAttributeValueOperation: 	 	"Atribut baru + operasi nilai",
        newCombineAttributeOperation: 	 	"Operasi atribut kombinasi baru",
        combineName: 	 	"Nama atribut gabungan",
        attributeOne: 	 	"Atribut satu",
        calculate: 	 	"Perhitungan",
        value: 	 	"Nilai",
        attributeDetails: 	 	"Detail atribut",
        updateTime: 	 	"Perbarui waktu",
        edit: 	 	"Edit",
        loadAttributeConfigure: 	 	"Muat konfigurasi atribut",
        loadAttributeName: 	 	"Muat nama atribut",
        attributeType: 	 	"Jenis nilai atribut",
        combineAttributeNumber: 	 	"Label atribut komposit",
        attributeValue: 	 	"Nilai atribut",
        newTicket: 	 	"Tiket baru",
        oldTicket: 	 	"Tiket lama",
        completeTicket: 	 	"Tiket selesai",
        telephone: 	 	"Telepon",
        customerName: 	 	"nama pelanggan" ,
        dailyCollectionTimes: 	 	"Proses tiket dalam sehari",
        collectionTimes: 	 	"Berapa kali tiket di proses",
        lastCollectionTime: 	 	"Terakhir kali tiket diproses",
        lastCollectionRecord: 	 	"Hasil proses tiket" ,
        promiseToPayTime: 	 	"Waktu PTP",
        customerType: 	 	"Jenis costumer",
        overdueDays: 	 	"Hari keterlambatan",
        timeSinceLastProcessing: 	 	"Waktu sejak pemrosesan terakhir",
        collection: 	 	"Penagihan",
        ticketInfo: 	 	"Informasi Tiket",
        LatestPromisedRepaymentTime: 	 	"Waktu terakhir berjanji untuk membayar",
        customerDetailInformation: 	 	"Detail costumer",
        SMS: 	 	"sms",
        sendMessageToCustomer: 	 	"Kirim sms ke costumer",
        sendMessageToContactOne: 	 	"Kirim sms ke kontak 1",
        sendMessageToContactTwo: 	 	"Kirim sms ke kontak 2",
        selectMessage: 	 	"Silakan pilih template SMS",
        send: 	 	"Kirim",
        phone: 	 	"Telepon",
        contact1phone: 		"Hubungi kontak 1 - Telepon",
        relationship: 	 	"Hubungan",
        name: 	 	"Nama",
        contact2phone: 	"Hubungi kontak 2 - Telepon",
        contact3phone: 	 	"Hubungi kontak 3 - Telepon",
        familyPhone: 	 	"Telepon rumah",
        autoCallResult: 	 	"Hasil Autocall",
        logCollectionDetails: 	 	"Record hasil penagihan",
        relief: 	 	"Keringanan",
        contactWay: 	 	"Metode menghubungi",
        contactTime: 	 	"Waktu panggilan",
        targetContact: 	 	"Telepon ke",
        connection: 	 	"Status koneksi telepon",
        willingnessToPay: 	 	"Kesediaan untuk membayar kembali",
        overdueReason: 	 	"Alasan terlambat",
        collectionResult: 	 	"Hasil koleksi",
        remark: 	 	"Komentar" ,
        saveCollectionDetail: 	 	"Simpan catatan koleksi",
        repaymentInfo: 	 	"Informasi pembayaran",
        VAaccount: 	 	"akun WA",
        OXXOMarketPaymentCode: 		"Kode pembayaran toko swalayan OXXO",
        PaynetMarketPaymentCode: 		"Kode pembayaran toko swalayan Paynet",
        remainingAmountDue: 	 	"Sisa jatuh tempo",
        marketPayAmount: 		"Jumlah kode pembayaran toserba",
        OXXOMarketPaymentCodeAmount: 	 	"Jumlah kode pembayaran toserba OXXO (termasuk biaya penanganan)",
        PaynetMarketPaymentCodeAmount:  	"Jumlah kode pembayaran toserba Paynet (termasuk biaya penanganan)",
        refreshOXXOMarketPaymentCode: 	 	"Perbarui jumlah kode pembayaran toko swalayan",
        OXXONeedFee: 		"Pembayaran OXXO, pengguna juga perlu membayar biaya penanganan",
        PaynetNeedFee: 		"Pembayaran paynet, pengguna juga perlu membayar",
        LoanInfo: 	 	"Informasi pinjaman",
        RemainingAmountDue: 	 	"Total kekurangan pembayaran",
        OverdueDays: 	 	"Hari keterlambatan",
        ActualRepaymentAmount: 	 	"Total pengembalian dana",
        TotalRepaymentAmount: 	 	"Total tagihan",
        CollectionStaff: 	 	"Staff penagihan",
        TargetContact: 	 	"Telepon ke",
        CommunicationTools: 	 	"Metode penagihan",
        Contact: 	 	"Nomor kontak",
        ContactTime: 	 	"Waktu panggilan",
        answerTime: 	 	"Waktu angkat telepon",
        endTime: 	 	"Waktu akhiri telepon",
        hangupDirection: 	 	"Penutup telepon",
        hangupCause: 	 	"Alasan Telpon ditutup",
        isNotConnect: 	 	"Apakah terhubungi",
        PromiseToPayTime: 	 	"Waktu pembayaran yang dijanjikan",
        WillingnessToRepay: 	 	"Kesediaan untuk membayar kembali",
        CollectionResult: 	 	"Alasan tidak terhubung",
        record: 	 	"Hasil" ,
        DueDate: 	 	"Tanggal pengembalian dana",
        Principal: 	 	"Pengembalian dana",
        ReceivedRepaymentOfPrincipal: 	 	"Pinjaman yang sudah di bayar",
        GracePeriodInterest: 	 	"Bunga yang harus dibayar",
        ReceivedRepaymentOfGracePeriodInterest: 	 	"Bunga yang sudah dibayar",
        PenaltyAndExtraFeesThatShouldBePaid: 	 	"Denda yang harus di bayar",
        ReceivedRepaymentOfPenalty: 	 	"Denda yang sudah dibayar",
        autoCallTime: 		"Waktu panggilan keluar otomatis",
        Nickname: 		"Nama panggilan",
        OnlineOrNot: 		'Apakah sedang online',
        AreYouSure: 		'Apakah yakin',
        Sure: 		'Setuju',
        Cancel: 		'Batalkan',
        DeductionOfPrincipal: 		'Keringanan pinjaman',
        InterestReduction: 		'Keringanan bunga pinjaman',
        RecordCollectionResults: 		'Rekaman hasil penagihan',
        Connect: 		'Tersambung',
        NotConnected: 		'Tidak terhubung',
        LoanOrderNumber: 		'Nomor id pinjaman',
        Collection: 		'Situasi penagihan',
        PaymentRecord: "Catatan pembayaran",
        RepaymentPlan: 		'Record pengembalian dana',
        AutomaticOutgoingCallRecord: 		'Record autocall',
        RecordCollectionRecord: 		'Record penagihan',
        CommitmentRepaymentTime: 		'Waktu pembayaran yang dijanjikan',
        Reminder: 		'Pengingat',
        CallObject: 		'Telepon ke',
        CollectionMethod: 		'Metode penagihan',
        ContactNumber: 		'nomor kontak',
        PhoneCallTime: 		'Waktu panggilan',
        ResponseTime: 		'Waktu merespon',
        EndTime: 		'Akhir waktu',
        OnhookDirection: 		'Penutup telepon',
        ReasonForHangingUp: 		'Alasan Telpon ditutup',
        WhetherToDial: 		'Apakah akan menelepon?',
        ReasonForNotReturning: 		'Alasan tidak mengembalikan dana',
        ReasonForNotConnecting: 		'Alasan tidak terhubung',
        Result: 		'Hasil',
        Recording: 		'Record',
        AutomaticOutgoingTime: 		'Waktu panggilan keluar otomatis',
        WhetherToCommunicate: 		'Apakah terhubung',
        EnterThePartialRepaymentAmount: 		'Silakan masukan jumlah pembayaran yang dikomunikasikan dengan pengguna',
        Attention: 		'Melihat',
        RemainingAmountOfTheOrder: 		'Jumlah sisa pesanan yang harus dilunasi',
        OrderId: 	'	ID pinjaman',
        BillId: 	'	ID tagihan',
        ActualPaymentDate: 		'Waktu pengembalian pinjaman',
        ActualRepaymentPrincipal: 		'Pinjaman yang sudah di bayar',
        RemissionDay: 		'Waktu pemberian keringanan',
        ReferralDirector: 		'Pinjaman yang sudah di potong',
        TheRemainingPrincipalCanBeReduced: 		'Sisa pinjaman yang bisa di potong',
        Reason: 		'Alasan',
        ActualInterestPaidDuringGracePeriod: 		'Bunga keterlambatan',
        PenaltyInterestActuallyPaid: 		'Bunga keterlambatan yang sudah dibayarkan',
        GracePeriodInterestRemissiond: 		'Bunga keterlambatan yang sudah dipotong',
        RemissiondPenaltyInterest: 		'Denda yang sudah dipotong',
        TheRemainingPenaltyInterestCanBeRemission: 		'Denda tersisa dapat dikurangi atau dibebaskan',
        RemissionOfGracePeriodInterest: 	'	Pembebasan bunga keterlambatan',
        RemainingDeductibleInterestFromTheGracePeriod: 		'Sisa bunga keterlambatan yang dapat dikurangkan',
        repayStatus: "Estado de presentación de informes",
        repayStatus0: "Cuestiones de reembolso pendientes de tramitación por CS",
        repayStatus1: "Esperando la verificación bancaria / tripartita",
        repayStatus2: "Masalah pembayaran kembali yang dapat diunggah",
        tryCalc: "Simulasi Perhitungan",
        ApplyForInterestFreeze: "Apply for an interest freeze",
      },
      Dialer: {
        userName: 		'nama pengguna',
        extnumber: 	 	'Nomor ekstensi ',
        assignStatus: 	 	'Status alokasi',
        assigned: 	 	'Ditugaskan ',
        unassigned: 	 	'Belum ditugaskan',
        supplier: 	 '	Pihak ketiga',
        InquiryExtensionNumberStartRange: 	 	'Kueri rentang awal nomor ekstensi',
        InquiryExtensionNumberEndRange: 	 	'Kueri rentang akhir nomor ekstensi',
        addTime: 	 	'Tambahkan waktu',
        addTheExtensionNumber: 	 	'Tambahkan nomor ekstensi',
        deleteExtensionNumber: 	 	'Hapus nomor ekstensi',
        submit: 	 	'Kirimkan ',
        roleList: 	 	'Daftar peran',
        unassign: 	 	'Batalkan penetapan',
        assignStaff: 	 	'Tugaskan karyawan',
        staffID: 	 	'ID karyawan',
        assignTime: 	 	'Waktu dibagikan',
        talkTime: "durasi panggilan", 
        unassignTime: 	 	'Batalkan penetapan waktu',
      },
      systemAttribute: {
        attributeName: 		'Nama atribut',
        attributeDescription: 		'Deskripsi properti',
        parameterValue: 		'Nilai atribut',
        submit: 		'Berikan',
        NewSystemParameters: 		'Tambahkan parameter sistem',
      },
      phoneVerify: {
        workStatus: "Status Kerja",
        isAttendance: "Absensi",
        batchOperations: "Lakukan Batch",
        orderTime: "Waktu Tiket",
        PVCommissioner: "Anggota PV",
        IRCommissioner: "Anggota IR",
        batchOrders: "Batch Tiket",
        batchStopOrders: "Batch Berhentikan Tiket",
        stopAcceptTicket: "Berhenti Terima Tiket",
        continueAcceptTicket: "Terima Tiket"

      },
      userInfo: {
        identityInformation: 		'Informasi Identitas',
        name: 		'nama pelanggan',
        gender: 		'jenis kelamin',
        IDType: 		'Jenis ID pengenal',
        IDNumber: 		'Nomor KTP',
        mobileNumber: 		'Nomor HP',
        email: 		'Email',
        versionName: 		'Nama Versi Aplikasi pelanggan',
        versionCode: 		'Nomor versi di GP',
        imageData: 		'Data gambar',
        IDPhoto: 		'Foto KTP',
        handheldPhoto: 		'Pegang foto KTP',
        otherInfomation: 		'Informasi lainnya',
        personalInfomation: 		'Informasi pribadi',
        marriageStatus: 		'Status menikah',
        birthday: 		'Tanggal lahir',
        numberOfChildren: 		'Jumlah anak',
        currentAddress: 		'Alamat sekarang',
        detailAddress: 	'	Detail alamat',
        educationStatus: 		'Jenjang pendidikan',
        famialyPhone: 		'Nomor telepon rumah',
        disbursementType: 		'Metode pencairan dana',
        bankName: 		'Nama Bank',
        bankNumber: 		'Nomor rekening bank',
        workInformation: 		'Informasi perkerjaan',
        workType: 		'Jenis perkerjaan',
        monthlyIncome: 		'Pendapatan bulanan',
        lengthOfWork: 		'Lama berkerja',
        companyPhoneNumber: 	'	Telepon kantor',
        companyName: 		'Nama kantor',
        companyAddress: 		'Lokasi kantor (provinsi, kota)',
        salaryDay: 		'Tanggal menerima gaji',
        contactInformation: 		'Informasi kontak pribadi',
        contact1Name: 		'Kontak pribadi  1',
        contact1Relationship: 		'Hubungan dengan kontak pribadi 1',
        phone: 		'Telepon',
        contact2Name: 		'Kontak pribadi 2',
        contact2Relationship: 		'Hubungan dengan kontak pribadi 2',
        communicationTime: 		'Waktu komunikasi',
        communicator: 		'Penghubung',
        contents: 		'Konten komunikasi',
        remark: 		'Komentar',
        loanHistory: 		'ID pinjaman',
        loanAmount: 		'Jumlah pinjaman',
        loanTerms: 		'Penghubung',
        loanStatus: 		'Status pinjaman',
        applyTime: 		'Waktu pengajuan pinjaman',
        processingTime: 		'Waktu verifikasi pinjaman',
        loanTime: 		'Waktu pencairan pinjaman',
        closingTime: 		'Waktu pengembalian pinjaman',
        overdueDays: 		'Hari Terlambat',
        ChangeHistory: 		'Riwayat perubahan',
        BorrowingHistory: 		'Riwayat peminjaman',
        AccountNumber: 		'Akun',
        UpdateItems: 		'Pembaharuan Data',
        OriginalValue: 		'Data asli',
        TheCurrentValue: 		'Data sekarang',
        TimeChange: 		'Waktu pengubahan',
        ModifiedBy: 		'Nama pengubah',
        TheTerm: 		'Syarat',
        State: 		'Status',
        BillingMessage: 		'Pesan penagihan',
      },
      menu: {
        PaymentCodeList: 		'Daftar kode pembayaran',
        PaymentCodeHistory: 		'Riwayat kode pembayaran',
        AuthoritySystem: 		'Sistem izin',
        UserManagement: 		'manajemen pengguna',
        RoleManagement: 		'Manajemen peran',
        AuthorityManagement: 		'manajemen otoritas',
        RolegroupManagement: 		'Manajemen kelompok peran',
        GroupRightsManagement: 		'Manajemen otoritas grup',
        SystemParameterConfiguration: 		'Konfigurasi parameter sistem',
        QuestionLibraryConfig: 		'Konfigurasi pustaka pertanyaan audit',
        CaseClassification: 		'Klasifikasi kasus',
        RecordingQuality:'Merekam daftar pemeriksaan kualitas',
        QualityInspectionRecording:'Merekam manajemen perintah kerja inspeksi kualitas',
        CollectTicketSystem: 		'Sistem tiket kerja',
        TicketManage: 		'Manajemen tiket kerja',
        AttributeConfigure: 		'Konfigurasi properti',
        TicketBasicAttribute: 		'Atribut tiket',
        TicketCombineAttribute: 		'Atribut portofolio perintah kerja',
        LoadAttributeConfigure: 		'Muat konfigurasi atribut',
        RuleConfiguration: 		'Konfigurasi aturan',
        GenerationRule: 		'Aturan pembuatan tiket',
        DistributionRules: 		'Aturan pembagian tiket',
        RecyclingRules: 		'Aturan penarikan tiket',
        OutsourcingRules: 		'Aturan outsourcing',
        WorkOrderProcessingList: 		'Daftar pemrosesan tiket kerja',
        Collection: 		'Penagihan',
        RepaymentReminder: 		'Pengingat pembayaran',
        DialerManagement: 		'Manajemen telepon',
        VoipManagement: 		'manajemen voip',
        NxManagement: 		'konfigurasi NX',
        ExtensionManagement: 'Manajemen Ekstensi',
        PerformanceManagement: 		'Manajemen kinerja',
        PersonalPerformance: 		'Performa pribadi',
        PersonalPerformance2: "Hourly Collection Data",
        PerformanceComparison: 		'Perbandingan kinerja',
        DistributeHistory: 		'Riwayat alokasi tiket',
        CollectionSystem: 		'C2 Sistem Penagihan',
        callRecords: 		'Riwayat penagihan',
        PaymentCodeInquire: 		'Permintaan kode pembayaran',
        salaryReport: 		'Laporan gaji',
        WhatsAppManage:'whatsAPP mengelola',
        WhatsAppLogin:'manajemen akun whatsapp',
        WhatsAppChat:'whatsAPP聊天',
        StaffBasicProperty: "Properti dasar staf",
        StaffCombProperty: "Properti kombinasi staf",
        Dashboard: "Dasbor",
        DashboardScreen: "Layar dasbor",
        LoggingManagement: "Manajemen log",
        SystemOperationLog: "Log operasi sistem",
        ThirdPartyRequestLog: "Log permintaan pihak ketiga",
        pageTips: 'Setiap aktivitas yang anda lakukan tercatat dan tersimpan dalam riwayat sistem, mohon untuk tidak menggunakan data perusahaan untuk kepentingan pribadi, penggunaan data perusahaan untuk kepentingan pribadi akan dimintai pertanggungjawabannya!'
      },
      lang: {
        Spanish: "Español",
        Chinese: "中文",
        English: "English",
        Vietnam: "Tiếng Việt",
        Arabic:' بالعربية ',
        indo:"bahasa Indonesia",
      },
      v0703: {
        Caseid: 		'ID Kasus',
        TicketOperate: 		'Operasi tiket kerja',
        PleaseEnterOrSelectRole: 		'Silakan masukkan atau pilih peran',
        CreationTime: 		'Waktu pembuatan ',
        LoadAttributesName: 		'Muat nama atribut',
        PleaseEnterOrSelectAnAttributes: 		'Silakan masukkan atau pilih atribut',
        LoadAttributesNumber: 		'Muat nomor atribut',
        LoadAttributesDescription: 		'Muat deskripsi atribut',
        LoadAttributesType: 		'Muat jenis atribut',
        CombinedPropertyName: 		'Nama atribut kombinasi',
        NumericalValue: 		'Nilai numerik',
        Options: 		'Pilihan',
        Time: 		'Waktu',
        CrowdOrder: 		'Peringkat kinerja',
        Save: 		'Simpan',
        PleaseEnter: 		'Silakan masuk',
        TicketUnassign: 		'Batalkan pembagian tiket',
        ViopNumberUnassign: 		'Batalkan penetapan ekstensi',
        NewAddition: 		'Tambahkan',
        TicketAssignStaff: 		'Nama Karyawan penerima tiket',
        TicketStaffId: 		'Nomor ID karyawan' ,
        TicketUnassignTime: 		'Waktu pembatalan tiket',
        ByDay: 		'Setiap hari',
        Hour: 		'Setiap jam',
        ParameterValue: 		'Nilai parameter',
      },
      v0707: {
        FirstsubsequentLoan: 		'pinjaman pertama dan pinjaman ulang',
        FirstLoan: 		'pinjaman pertama',
        Reloan: 		'pinjaman ulang',
        Yes: 		'Ya' ,
        No: 		'Tidak'	,

      },
      annotation: {
        AnnotationManagement: "标注管理",
        AnnotationTicketManagement: "标注工单管理",
        AnnotationTicketList: "标注工单列表",
      },
      smsPushTask: {
        multilingualTitle: "Judul Multibahasa",
        multilingualContent: "Konten Multibahasa",
        multilingualStatus: "Status Multibahasa",
        label: "Label",
        state: "Status",
        addMultilingual: "Tambah Bahasa",
        multilingualDesc: "Deskripsi dalam Multibahasa",
        relateSmsTask: "Kaitkan Tugas SMS",
        relatePushTask: "Kaitkan Tugas Push",
        operator: "Operator",
        changeState: "Ubah Status",
        editContent: "Edit Konten",
        addMultilingualContent: "Tambahkan Konten dalam Multibahasa",
        selectLanguage: "Pilih Bahasa",
        varLibrary: "Pustaka Variabel",
        multiContentManage: "Manajemen Multibahasa",
      },
    ...idLocale,
    ...performanceId,
    ...JSON.parse(trans),
    // ...JSON.parse(hom),
      // ...langId,
    ...fhbLangId,
    ...wrhLangId,
    ...lxyLangId,
    ...DyLangId,
    ...lgyLangId,
    ...lssLangId
}

export default id;
